var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single_list d-flex justify-content-between flex-wrap"},[_c('p',[_c('b-avatar',{attrs:{"variant":"warning","src":_vm.app.imgURL,"alt":_vm.app.name,"rounded":""}})],1),_c('p',[_vm._v(_vm._s(_vm.app.name))]),_c('div',{staticClass:"list_details"})])
}
var staticRenderFns = []

export { render, staticRenderFns }